import React, { Suspense, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { FormContainer } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import AddressComponent from '../../Components/CompanyForm/Address';
import CompanyInfo from '../../Components/CompanyForm/CompanyInfo';
import LogoInput from '../../Components/Form/LogoInput';
import ResultModal from '../../Components/Modal/ResultModal.component';
import PageScroller from '../../Components/PageScroller/PageScroller.component';
import SettingsButtons from './SettingsSubmit.component';

const CompanySettingsInner = ({ company: c }) => {
  const [company, setCompany] = useState(c || {});
  const [address, setAddress] = useState(c?.address || []);
  const [isOpen, setIsOpen] = useState(false);
  const [successState, setSuccessState] = useState('');
  const [logo, setLogo] = useState('');
  useEffect(() => {
    setCompany(c);
    setAddress(c?.address[0]);
    setLogo(c?.logo);
  }, [c]);

  return (
    <FormContainer>
      <Suspense fallback={<p>Loading breadcrumbs...</p>}>
        <BreadCrumbs
          one="Company Dashboard"
          oneLink="/company"
          two="Settings for Company"
        />
      </Suspense>
      <h2>Edit Company</h2>
      <form>
        <Suspense fallback={<p>Loading company info...</p>}>
          <CompanyInfo company={company} setCompany={setCompany} />
        </Suspense>
        <Suspense fallback={<p>Loading address form...</p>}>
          <AddressComponent
            billingAddress={address}
            setBillingAddress={setAddress}
          />
        </Suspense>
        <Suspense fallback={<p>Loading logo input...</p>}>
          <LogoInput image={logo} setImage={setLogo} />
        </Suspense>
        <Suspense fallback={<p>Loading result modal...</p>}>
          <ResultModal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            result={successState}
            linkTo="/company"
          />
        </Suspense>
        <Suspense fallback={<p>Loading form buttons...</p>}>
          <SettingsButtons
            company={company}
            address={address}
            logo={logo}
            setIsOpen={setIsOpen}
            successState={successState}
            setSuccessState={setSuccessState}
          />
        </Suspense>
      </form>
      <Suspense fallback={<p>Loading page scroller...</p>}>
        <PageScroller />
      </Suspense>
    </FormContainer>
  );
};
CompanySettingsInner.propTypes = {
  company: PropTypes.object,
};

export default CompanySettingsInner;
